import { create } from 'zustand';

export type ToastType = 'success' | 'error' | 'info' | 'warning';

interface Toast {
    id: string;
    message: string;
    type: ToastType;
    title?: string;
}

interface ToastStore {
    toasts: Toast[];
    showToast: (message: string, type?: ToastType, title?: string) => void;
    hideToast: (id: string) => void;
}

export const useToastStore = create<ToastStore>((set) => ({
    toasts: [],
    showToast: (message, type = 'error', title) => {
        const id = Math.random().toString(36).substring(2, 9);
        const newToast = { id, message, type, title };
        
        set((state) => ({ toasts: [...state.toasts, newToast] }));

        // Auto-dismiss after 5 seconds
        setTimeout(() => {
            set((state) => ({
                toasts: state.toasts.filter((t) => t.id !== id),
            }));
        }, 5000);
    },
    hideToast: (id) => {
        set((state) => ({
            toasts: state.toasts.filter((t) => t.id !== id),
        }));
    },
}));
